import { getSessionValue } from '../session'

type Utms = {
  medium?: string
  campaign?: string
  parceiro?: string
}

type UtmConfig = {
  group: string
  source: string
  defaultMedium: string
}

const UTM_CONFIGS: Record<'blog' | 'direct' | 'organic', UtmConfig> = {
  blog: { group: 'organic', source: 'Blog', defaultMedium: 'search' },
  direct: { group: 'Direto', source: 'Direto', defaultMedium: 'direto' },
  organic: { group: 'organic', source: 'Site (Orgânico)', defaultMedium: 'organico' }
}

export const buildSimulatorUrl = (pathname: string, utm: Utms = {}, withValuesInSession = false) => {
  const origin = getSessionValue('origem')
  const originPage = getSessionValue('originPage')
  const campaignData = getSessionValue('campaignData')

  const baseUrl = withValuesInSession
    ? process.env.NEXT_PUBLIC_SIMULATOR_LINK_WITH_VALUES
    : process.env.NEXT_PUBLIC_SIMULATOR_LINK

  const formValues = withValuesInSession
    ? {
        propertyValue: getSessionValue('propertyValue'),
        loanAmount: getSessionValue('loanAmount'),
        personType: getSessionValue('personType'),
        state: getSessionValue('state')
      }
    : {}

  if (campaignData?.includes('utm_source')) {
    const query = withValuesInSession
      ? `${campaignData.substring(1)}&${_objectToQueryString(formValues)}`
      : campaignData.substring(1)

    return `${baseUrl}?${query}`
  }

  const isUserFromBlog = originPage?.match(/blog\/.*/) !== null
  const utmConfig = isUserFromBlog ? UTM_CONFIGS.blog : origin === 'direto' ? UTM_CONFIGS.direct : UTM_CONFIGS.organic

  const firstPage = originPage === '/' ? 'Home' : _pathToCamelCase(originPage ?? '')
  const currentPage = pathname === '/' ? 'Home' : _pathToCamelCase(pathname)
  const utmMedium = utm.medium ? _pathToCamelCase(utm.medium) : utmConfig.defaultMedium

  const search = _omitFalsy({
    utm_group: utmConfig.group,
    utm_source: utmConfig.source,
    utm_medium: _getUtmMedium(utmMedium),
    utm_term: firstPage,
    utm_campaign: utm.campaign ?? currentPage,
    parceiro: utm.parceiro,
    ...formValues
  })

  return `${baseUrl}?${_objectToQueryString(search)}`
}

const _omitFalsy = (object: Record<string, unknown>) =>
  Object.keys(object).reduce((acc, key) => {
    if (object[key]) return { ...acc, [key]: object[key] }
    return acc
  }, {})

const _objectToQueryString = (object: Record<string, unknown>) => {
  const search = new URLSearchParams('')
  Object.entries(object).forEach(([key, value]) => {
    search.set(key, value as string)
  })
  return search.toString().replace(/\+/g, '%20')
}

const _pathToCamelCase = (path: string) =>
  path
    .replace(/\/|\s/g, '|')
    .split('|')
    .reduce((accumulator, word) => `${accumulator}${_capitalizeFirstLetter(word)}`, '')

const _capitalizeFirstLetter = (word: string) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`

const _hasPaidMediaParams = (urlParams: URLSearchParams) =>
  urlParams.has('utm_source') || urlParams.has('gclid') || urlParams.has('fbclid')

const _getUtmMedium = (defaultMedium: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  if (_hasPaidMediaParams(urlParams)) return defaultMedium
  return urlParams.get('utm_medium') ?? defaultMedium
}
